import React, { useState } from "react";
import PropTypes from "prop-types";
import { Field, Control, Label, Input } from "rbx";
import FilterButtons from "../../../components/FilterButtons";
import {
  BooleanInput,
  EmployeeSelect,
  SystemCodeSelect
} from "../../../components/inputs";

const INITIAL_FILTER_STATE = {
  Status: true
};

const DrugTestFilters = ({ filters, onFilter, onClose }) => {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({
      ...inputs,
      [e.target.name]:
        e.target.name.includes("BatchNo") ||
        e.target.name.includes("EmployeeRecIdRef") ||
        e.target.name.includes("TestSiteRecIdRef") ||
        e.target.name.includes("DispositionRecIdRef")
          ? parseInt(value)
          : value
    });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <EmployeeSelect
            icon="user"
            label="Employee"
            name="EmployeeRecIdRef"
            value={inputs.EmployeeRecIdRef}
            variables={{
              where: { DrugTest: true },
              orderByMulti: ["LastName_ASC"]
            }}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>Batch No</Label>
          <Input
            name="BatchNo"
            type="number"
            value={inputs.BatchNo}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <SystemCodeSelect
            icon="globe"
            label="Test Site"
            lookup={{ Category: "DrugTest", Code: "TestSite" }}
            name="TestSiteRecIdRef"
            showHelp={false}
            value={inputs.TestSiteRecIdRef}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <SystemCodeSelect
            icon="book-open"
            label="Disposition"
            lookup={{ Category: "DrugTest", Code: "TestDisposition" }}
            name="DispositionRecIdRef"
            orderByMulti={["ListOrder_DESC", "CodeDescription_ASC"]}
            value={inputs.DispositionRecIdRef}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Status"
            value={inputs.Status}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
};

DrugTestFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};

export default DrugTestFilters;
